import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { HistoryLogsComponent } from 'src/app/core/dialogs/history-logs/history-logs.component';
import { BtnCellRendererDeleteClipboard } from 'src/app/core/grid/btn-cell-render-delete ';
import { HistoryService } from 'src/app/service/history.service';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { ReportDownloadComponent } from 'src/app/core/dialogs/report-download/report-download.component';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  standalone: false,
})
export class HistoryComponent implements OnInit {
  gridApi: any;
  columnDefs = [];
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  successMessage;
  errorMessage;
  icons;
  isAccessible: boolean = false;
  originalRowdata: any;
  gridOptions: any;
  totalRecords = 0;
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ];
  originalPage: any;
  paginationPageSize: number = 30;
  dynamicHeight: number;

  constructor(
    public dialog: MatDialog,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly eboiStateService: EboiStateService,
    private readonly constants: Constants,
    private readonly router: Router,
    private readonly historyService: HistoryService,
  ) {
    this.context = {
      componentParent: this,
    };
    this.defaultColDef = {
      suppressMovable: true,
      wrapText: true,
    };
    this.gridOptions = {
      suppressCellSelection: true,
      context: this.context,
    };
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles();
    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'queueId',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        width: 40,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'Process',
        field: 'type',
        width: 80,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'Created',
        field: 'createdTime',
        width: 100,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
        comparator: this.dateComparator,
      },
      {
        headerName: 'Completed',
        field: 'completedTime',
        width: 100,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
        comparator: this.dateComparator,
      },
      {
        headerName: 'Completed By',
        field: 'completedByUser',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        width: 160,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'Delete/Logs/Reports',
        field: 'history_deleteclipboard',
        width: 70,
        cellRenderer: BtnCellRendererDeleteClipboard,
      },
    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };

    this.refreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) {
      // NOSONAR
      return 0;
    }
    if (date1Number == null) {
      // NOSONAR
      return -1;
    }
    if (date2Number == null) {
      // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // } // Commented for APM integration
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
    this.updatePaginationDetails();
  }

  goToLastPage() {
    this.gridApi.paginationGoToLastPage();
    this.updatePaginationDetails();
  }

  goToNextPage() {
    this.gridApi.paginationGoToNextPage();
    this.updatePaginationDetails();
  }

  goToPreviousPage() {
    this.gridApi.paginationGoToPreviousPage();
    this.updatePaginationDetails();
  }

  onPageSizeChanged(event: any) {
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }

  getCurrentPage(): boolean {
    if (this.cPage == 1) {
      // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.currentPageForTotalPage = Number(this.cPage);
    if (this.tPage == this.currentPageForTotalPage) {
      // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }

  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();

      this.sRecord =
        this.gridApi.paginationGetPageSize() *
          this.gridApi.paginationGetCurrentPage() +
        1;
      this.eRecord =
        this.gridApi.paginationGetPageSize() *
          this.gridApi.paginationGetCurrentPage() +
        this.gridApi.paginationGetPageSize();
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord =
        this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  folderPopUp(data, _pagename) {
    const dialogRef = this.dialog.open(ReportDownloadComponent, {
      disableClose: true,
      width: '502px',
      data: {
        header: 'Are you sure you want to delete this History?',
        data: this.originalRowdata,
        queueId: data.queueId,
      },
    });
    console.info(dialogRef);
  }

  deleteTemplateRow(data, pagename) {
    let displayRowIndex;
    if (pagename == 'history_deleteclipboard') {
      // NOSONAR

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        data: {
          header: 'Are you sure you want to delete this History?',
          description: `ID:  ${data.queueId} ,  Type: ${data.type}`,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.event == 'ConfirmEvent') {
          // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent);
          this.historyService.deleteHistory(data.queueId).subscribe(
            (response) => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
              if (response == 'Success') {
                // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = '';
                  this.errorMessage = '';
                }, this.constants.notificationMessageTimeShort);
                displayRowIndex = this.displayRowData.findIndex(
                  (x) => x.queueId == data.queueId,
                ); // NOSONAR
                this.displayRowData.splice(displayRowIndex, 1);
                this.gridApi?.setGridOption('rowData', this.displayRowData);
                this.rowCount = this.displayRowData.length;
                this.totalRecords = this.displayRowData.length;
              }
            },
            (error) => {
              console.info(error);
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = '';
                this.errorMessage = '';
              }, this.constants.notificationMessageTimeShort);
            },
          );
        }
        this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
      });
    }
  }

  clipboardTemplateRow(data, pagename) {
    if (pagename == 'history_deleteclipboard') {
      // NOSONAR

      const dialogRef = this.dialog.open(HistoryLogsComponent, {
        disableClose: true,
        width: '800px',
        data: {
          eventType: 'VIEWLOGS',
          queueId: data.queueId,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.event == 'CloseEvent') {
          // NOSONAR
          console.info('something');
        }
      });
    }
  }

  refreshData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.historyService.loadDataHistory().subscribe(
      (response) => {
        this.originalRowdata = response;
        this.displayRowData = response.filter(
          (item, index, arr) =>
            arr.findIndex(
              (t) =>
                t.queueId == item.queueId &&
                t.type == item.type &&
                t.createdTime == item.createdTime &&
                t.completedTime == item.completedTime && // NOSONAR
                t.completedByUser == item.completedByUser,
            ) == index,
        ); // NOSONAR
        console.info('displayRowData', this.displayRowData);
        this.totalRecords = this.displayRowData.length;
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        setTimeout(() => {
          this.updatePaginationDetails();
        });
      },
      (error) => {
        console.info(error);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, this.constants.notificationMessageTimeShort);
      },
    );
  }
}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) {
    // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return (
    yearNumber * 100000000 +
    monthNumber * 1000000 +
    dayNumber * 10000 +
    hourNumber * 100 +
    minNumber
  );
}
